import { render, staticRenderFns } from "./newSR.vue?vue&type=template&id=61e9f923&scoped=true&"
import script from "./newSR.vue?vue&type=script&lang=js&"
export * from "./newSR.vue?vue&type=script&lang=js&"
import style0 from "./newSR.vue?vue&type=style&index=0&id=61e9f923&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e9f923",
  null
  
)

export default component.exports